import React from 'react'
import PropTypes from 'prop-types';
import Button from './Button';

function CheckboxButton({
	className,
	id,
	label,
	formikProps,
	onClick
}) {
	
	const handleClick = () => {
		const value = formikProps.values[id];
		formikProps.setFieldValue(id, !value);
		onClick();
	}

	return (
		<Button
			className={className}
			onClick={handleClick}
		>
			{label}
		</Button>
	)
}

CheckboxButton.propTypes = {
	formikProps: PropTypes.object,
	id: PropTypes.string.isRequired,
	label: PropTypes.string,
	onClick: PropTypes.func,
}

CheckboxButton.defaultProps = {
	onClick: () => {}
}

export default CheckboxButton